export function parseQuerystring(querystring: string): { [key: string]: string } {
  const entries = new URLSearchParams(querystring).entries();
  const usableEntries: { [key: string]: string } = {};
  for (const [key, value] of entries) {
    usableEntries[key] = value;
  }
  return usableEntries;
}
